import app from './Vue/app';
import CrestAnimation from '@components/about/CrestAnimation.vue';
import BobbleheadGallery from '@components/about/BobbleheadGallery.vue';

app.component('CrestAnimation', CrestAnimation);
app.component('BobbleheadGallery', BobbleheadGallery);
